export default Object.freeze({
  info    : 'info',
  warning : 'warning',
  error   : 'error',
});
